import { Divider, Stack, Typography } from '@mui/material';
import { signInWithRedirect } from 'aws-amplify/auth';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';

import { Button } from '@/shared/components/ui/button/button';
import { Paper } from '@/shared/components/ui/paper/paper.styled';
import { LoginWithCredentials } from '@/shared/features/auth/components/login-with-credentials/login-with-credentials';
import { LoginWithSso } from '@/shared/features/auth/components/login-with-sso/login-with-sso';

export const Login = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [loginInWithSso, setLoginInWithSso] = useState<boolean>(false);

  const idp = searchParams.get('idp');
  const company = searchParams.get('company');

  const signInWithIdp = async (idp: string) => {
    try {
      await signInWithRedirect({ provider: { custom: idp } });
    } catch (error) {
      console.error('SSO sign-in failed:', error);
    }
  };

  useEffect(() => {
    if (!idp && !company) {
      return;
    }

    void signInWithIdp(idp || company + '-idp');
  }, [idp, company]);

  const getSwitchButtonLabel = () => {
    return loginInWithSso
      ? t('auth:sign_in_with_credentials')
      : t('auth:sign_in_with_sso');
  };

  return (
    <Paper padding="2rem">
      <Stack gap="1.25rem">
        <Typography variant="h5" alignSelf="center">
          {t('auth:sign_in_to_your_account')}
        </Typography>
        {loginInWithSso ? <LoginWithSso /> : <LoginWithCredentials />}
        <Divider>
          <Typography variant="p8" color="textSecondary" marginX="1.25rem">
            {t('common:or')}
          </Typography>
        </Divider>
        <Button
          variant="secondary"
          fullWidth={true}
          size="large"
          onClick={() => setLoginInWithSso((prev) => !prev)}
        >
          {getSwitchButtonLabel()}
        </Button>
      </Stack>
    </Paper>
  );
};
